import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; 

function UserValidationPage() {
  const [userId, setUserId] = useState('');
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage('');
    setVariant('');

    if (!userId || !fechaNacimiento) {
      setMessage('Por favor, ingresa tu ID de usuario y fecha de nacimiento.');
      setVariant('danger');
      return;
    }
    if (validateRut(userId)) {
      try {
        const response = await fetch('https://api.grekad.cfcunap.cl/api/validar-usuario-fecha', {
          //const response = await fetch('http://localhost:5000/validar-usuario-fecha', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId, fechaNacimiento }),
        });

        const data = await response.json();

        if (data.success) {
          // Redirigir a la página de votación con el token en la URL
          navigate(`/votar?token=${data.token}`);
        } else {
          setMessage(data.message || 'Validación fallida. Inténtalo de nuevo.');
          setVariant('danger');
        }
      } catch (error) {
        setMessage('Hubo un error en la conexión con el servidor.');
        setVariant('danger');
      }
    } else {
      setMessage('Formato de RUT inválido. Ingrese el RUT sin puntos y con guion antes del dígito verificador.');
      setVariant('danger');
    }
  };
// Función para validar el formato del RUT
const validateRut = (rut) => {
  const rutRegex = /^[0-9]+-[0-9K]$/; // Solo números y un guion con dígito verificador
  return rutRegex.test(rut);
};
  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <div className="login-form">
      <h3>Validar Usuario</h3>
      {message && <Alert variant={variant}>{message}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formUserId" className="mb-3">
          <Form.Label>RUN</Form.Label>
          <Form.Control
            type="text"
            placeholder="12123123-K"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group controlId="formFechaNacimiento" className="mb-3">
          <Form.Label>Fecha de Nacimiento</Form.Label>
          <Form.Control
            type="date"
            placeholder="Ingresa tu fecha de nacimiento"
            value={fechaNacimiento}
            onChange={(e) => setFechaNacimiento(e.target.value)}
            required
          />
        </Form.Group>
        <div className="d-flex justify-content-center">
        <Button variant="primary" type="submit">
          Ingresar a Votar!
        </Button>
        </div>
      </Form>
      </div>
    </Container>
  );
}

export default UserValidationPage;

